export default __webpack_public_path__ + "static/media/2026-03-22 18.08.16.c1e94abd.jpg";